import { SIZES } from "@/const"
import { Vector2 } from "three"
export let mousePosition: Vector2 = new Vector2(0, 0)

let target: Vector2 = new Vector2(0, 0)

interface MouseOptions {
    max: Vector2
    min?: Vector2
    init: Vector2
}

const defaultOptions: MouseOptions = {
    max: new Vector2(0, 0),
    init: new Vector2(0, 0)
}

export function initMouseListener(userOptions?: Partial<MouseOptions>) {
    const opts: MouseOptions = {
        ...defaultOptions,
        ...userOptions
    }

    target = opts.init
    mousePosition = target

    const canvas = document.querySelector('#glcanvas') as HTMLCanvasElement
    canvas.addEventListener("pointermove", (event: MouseEvent) => {
        // target += event.deltaY
        // if (target > opts.max) target = opts.max
        // if (opts.min != undefined && target < opts.min) target = opts.min
        mousePosition.x = event.clientX / SIZES.width * 2 - 1
        mousePosition.y = - (event.clientY / SIZES.height) * 2 + 1

    })

    requestAnimationFrame(interpolate)
}

function interpolate(delta: number) {
    const diff = new Vector2(target.x, target.y).sub(mousePosition)
    mousePosition.add(diff.multiplyScalar(0.1))
    requestAnimationFrame(interpolate)
}
